import { ComponentChildren, CSSProperties } from "preact";
import { forwardRef } from "preact/compat";

type ButtonProps = {
  onClick?: (e: preact.TargetedMouseEvent<HTMLButtonElement>) => void;
  children: ComponentChildren;
  style?: CSSProperties;
  disabled?: boolean;
  className?: string;
  type?: "button" | "submit" | "reset";
  title?: string;
  onMouseDown?: (e: preact.TargetedMouseEvent<HTMLButtonElement>) => void;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      style,
      children,
      disabled,
      onClick,
      onMouseDown,
      className,
      title,
      type = "button",
    },
    ref,
  ) => (
    <button
      className={"button " + (className || "")}
      type={type}
      title={title}
      onMouseDown={onMouseDown}
      style={style}
      disabled={disabled}
      ref={ref}
      onClick={onClick}
    >
      {children}
    </button>
  ),
);
